import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M10.586 17.586 10 17l9-9a1.414 1.414 0 0 1 2 2l-7.586 7.586a2 2 0 0 1-2.828 0M5 13l2 2 1-1a1.414 1.414 0 0 1 2-2l4-4a1.414 1.414 0 1 1 2 2l-7.586 7.586a2 2 0 0 1-2.828 0L3 15a1.414 1.414 0 0 1 2-2"
    }
  )
);
var SvgDoubleCheckOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DoubleCheckOutlined_default = SvgDoubleCheckOutlined;

export { DoubleCheckOutlined_default as default };
